export default __webpack_public_path__ + "static/media/learn.cacd4844.png";